"use client";

import { useState } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Autocomplete, LoadScript } from "@react-google-maps/api";

const libraries = ["places"]; // Add the required libraries

export default function LocationDrawer({
  open,
  setOpen,
  setOtherAddress,
  otherAddress,
}) {
  const [coordinates, setCoordinates] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const handleOnLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const handlePlaceChange = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      setOtherAddress(place.formatted_address || "");
      if (place.geometry) {
        const { lat, lng } = place.geometry.location;
        setCoordinates({
          lat: lat(),
          lng: lng(),
        });
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className="relative z-10"
    >
      <div className="fixed inset-0" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
            <DialogPanel
              transition
              className="pointer-events-auto w-screen max-w-2xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
            >
              <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                <div className="px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <DialogTitle className="text-base font-semibold text-gray-900">
                      Add Vendor Location
                    </DialogTitle>
                    <div className="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      >
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon aria-hidden="true" className="size-6" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                  <span className="space-x-3">
                    <Autocomplete
                      onLoad={handleOnLoad}
                      onPlaceChanged={handlePlaceChange}
                    >
                      <input
                        type="text"
                        value={otherAddress}
                        onChange={(e) => setOtherAddress(e.target.value)}
                        placeholder="Enter an otherAddress"
                        className="border-gray-300 rounded-md text-sm w-[300px] lg:w-[400px] xl:w-[480px] ml-4 mt-5"
                      />
                    </Autocomplete>
                  </span>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
